<template>
  <fieldToggleShow
    v-model="item"
    v-bind="$attrs"
    counter
    :label="label"
    :noLabel="noLabel"
    :rules="currentRules"
  >
    <template v-for="(_, slot) in $slots" v-slot:[slot]="props">
      <slot v-bind="props" :name="slot" />
    </template>
  </fieldToggleShow>
</template>

<script>
import fieldToggleShow from './field-toggle-show.vue'
import rules from '@utils/rules'
export default {
  components: { fieldToggleShow },
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
    value: {},
    label: {},
    noLabel: Boolean,
  },
  data: () => ({ defaultRules: rules.password }),
  computed: {
    currentRules() {
      return [...this.rules, ...this.defaultRules]
    },
    item: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {},
}
</script>

<style scoped></style>
